module.exports = __webpack_public_path__ + "static/diamond-efc01942c0c6241169877278c671c15e.webp";